import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'

import { cn } from '~/lib/utils'

import type { TimeSlot } from '../../templates/booking-stepper'
import { TIME_SLOT_HEIGHT } from './helpers'

export interface GridDurationRowProps {
	rowTime: string
	isAvailable?: boolean
	value: TimeSlot
}

export const GridDurationRow = ({
	rowTime,
	isAvailable,
	value,
}: GridDurationRowProps) => {
	const isHalfHour = rowTime.includes(':30')

	const startAsMinutes = dateTimeUtils.utils.getTimeAsMinutes(value.start!)
	const endAsMinutes = dateTimeUtils.utils.getTimeAsMinutes(value.end!)
	const rowTimeAsMinutes = dateTimeUtils.utils.getTimeAsMinutes(rowTime)

	const showHalfHour =
		(value.start === rowTime || value.end === rowTime) && isAvailable
	const isHiglighted =
		startAsMinutes <= rowTimeAsMinutes && rowTimeAsMinutes <= endAsMinutes
	const showTime = (isHalfHour && showHalfHour) || !isHalfHour

	return (
		<div
			data-testid='grid-duration-row'
			className={cn(
				'relative w-full border-t border-l bg-white',
				isHalfHour ? 'border-t-transparent' : 'border-t-slate-200',
				isAvailable ? 'border-l-transparent' : 'border-l-primary',
			)}
			style={{
				height: TIME_SLOT_HEIGHT,
				...(!isAvailable && {
					background:
						'linear-gradient(to right bottom,#d1d1d1 6.25%,#ececec 0,#ececec 43.75%,#d1d1d1 0,#d1d1d1 56.25%,#ececec 0,#ececec 93.75%,#d1d1d1 0)',
					backgroundSize: '4.25px 4.25px',
				}),
			}}
		>
			{showTime && (
				<p
					className={cn(
						'-left-10 !text-xxs absolute w-[26px] select-none text-right',
						{
							'text-primary': isHiglighted,
							'text-slate-400': !isAvailable,
						},
					)}
					style={{ top: `${-TIME_SLOT_HEIGHT / 2}px` }}
				>
					{isHalfHour ? ':30' : rowTime}
				</p>
			)}
		</div>
	)
}
